// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T3duOCpntJ3j3aSwpgY3 {
  margin: 140px auto;
  width: 90%;
  max-width: 1440px;
}

.QlrOfPj5fVqQH5PVPgYQ {
  display: grid;
  grid-template-columns: repeat(2, 55%);
  margin-top: 2%;
}

.Oe0bAFkQfa3dyZYeCIdg {
  display: flex;
  flex-direction: column;
  width: 27vw;
  margin-left: 15%;
}

.Oe0bAFkQfa3dyZYeCIdg p {
  font-size: 18px;
}

.Oe0bAFkQfa3dyZYeCIdg hr {
  width: 100%;
}

.Oe0bAFkQfa3dyZYeCIdg .rLsXwUj3SxlBwBkbT065 {
  font-size: 26px;
  margin-bottom: 0;
}

.soIxxho0euBDB_conCww {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]};
}

.MMwp7ZNu68KDfi9q1cF3 {
  grid-column-start: 1;
  grid-row-start: 1;
  grid-row-end: 3;
}

.wzlaO_8nYQfnfJs82Qcv {
  display: flex;
  flex-direction: column;

  background-color: white;
  box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 30px;
  
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]};
}

.cOMf9LTb6eixcj43bcnJ {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.rLsXwUj3SxlBwBkbT065 {
  margin-bottom: 0;
  font-weight: bold;
}

.xHWm8E28W7APonRRWp5q {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-top: 50px;
}

.zTmzNvjGKC6pwL19Hsb7 {
  margin-right: 20px;
}

.O3TuKI_rOIMAv9ra88xa {
  font-weight: bold;
}

.JLttz2YIGzHEaMhjQ0Hp {
  margin-right: 5px;
}

.edWie6aJ006No8zDypag {
  margin-top: 30px;
}

.izCFl_joXr6lRcE4TvQm {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;

  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(0, 0, 0, 0.15);
}

.ruaLoH4u7UK7kEFIGgfM {
  background-color: white;
  border-radius: 5px;
  width: 550px;
  padding: 24px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.ruaLoH4u7UK7kEFIGgfM button {
  width: 100%;
}

.c7OtxqajS2zLVuS8Qky8 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.c7OtxqajS2zLVuS8Qky8 .qgg7QTVvAvzVmQmrbF8t {
    width: 100%;
    margin-right: 20px;
}


@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .QlrOfPj5fVqQH5PVPgYQ {
    display: flex;
    flex-direction: column-reverse;
  }

  .cOMf9LTb6eixcj43bcnJ {
    flex-direction: column;
  }

  .zTmzNvjGKC6pwL19Hsb7 {
    display: none;
  }

  .Oe0bAFkQfa3dyZYeCIdg {
    width: 90vw;
    margin: auto;
  }

  .YMM6knAIf3lZTG3Ymg18 {
    width: 100%;
  }
  
  .T3duOCpntJ3j3aSwpgY3 {
    width: 100%;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
  .ruaLoH4u7UK7kEFIGgfM {
    width: 90%;
    box-sizing: border-box;
  }
}

.JB8fgVVoKSBbf5XqTtYx {
  border: 1px solid #E2E9FC;
  border-radius: 5px;
  text-align: left;

  height: 48px;
  width: 100%;
  margin-right: 16px;
  margin-bottom: 16px;
  padding: 0 16px;
  font-size: 14px;

  transition: .3s;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.JB8fgVVoKSBbf5XqTtYx input {
  margin-right: 8px;
}

.JB8fgVVoKSBbf5XqTtYx:hover,
.dEtJi4Ahxb_SAsa8Q3oK {
  border-color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
}

.JB8fgVVoKSBbf5XqTtYx:disabled {
  background-color: #FAFBFE;
}

.JB8fgVVoKSBbf5XqTtYx:disabled:hover {
  border-color: #E2E9FC;
}

.Od3yb_80fxke1asbzx3g img+img {
  margin-left: 8px;
}



.ADqX5xYUlD2ZQV_E19xf {
  background-color: white;
  padding: 16px;
}

.c9SzhPohesHLGAeLPLCn {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 4px;
  margin-top: 0;
}

.M2PYiJBabPHuNEbglRcx {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: color-text-subtle;
  margin-top: 4px;
}

.KnJs4t0zLve7l7Ej8Emm {
  display: none;
}

.g3ZUyinLkKMFyq56LWWS {
  font-size: 16px;
  font-weight: 500;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
  .JB8fgVVoKSBbf5XqTtYx {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/InvoicingForm/InvoicingForm.module.css"],"names":[],"mappings":"AAMA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mDAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;;EAEb,mDAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;;EAEb,WAAW;EACX,aAAa;;EAEb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;;EAEtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;;AAGA;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;;EAEhB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;;EAEf,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,0DAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet-l, tablet from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-text, color-purple from colors;\n\n.content {\n  margin: 140px auto;\n  width: 90%;\n  max-width: 1440px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(2, 55%);\n  margin-top: 2%;\n}\n\n.recap {\n  display: flex;\n  flex-direction: column;\n  width: 27vw;\n  margin-left: 15%;\n}\n\n.recap p {\n  font-size: 18px;\n}\n\n.recap hr {\n  width: 100%;\n}\n\n.recap .title {\n  font-size: 26px;\n  margin-bottom: 0;\n}\n\n.recapSection {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  color: color-text;\n}\n\n.boxForm {\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-row-end: 3;\n}\n\n.flexBox {\n  display: flex;\n  flex-direction: column;\n\n  background-color: white;\n  box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.06);\n  border-radius: 10px;\n  padding: 30px;\n  \n  color: color-text;\n}\n\n.flexColumn {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.title {\n  margin-bottom: 0;\n  font-weight: bold;\n}\n\n.footerContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  margin-top: 50px;\n}\n\n.buttonBackTo {\n  margin-right: 20px;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.icon {\n  margin-right: 5px;\n}\n\n.switchCompany {\n  margin-top: 30px;\n}\n\n.background {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1000;\n\n  width: 100%;\n  height: 100vh;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.modal {\n  background-color: white;\n  border-radius: 5px;\n  width: 550px;\n  padding: 24px;\n  box-sizing: border-box;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal button {\n  width: 100%;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.row .inputContainer {\n    width: 100%;\n    margin-right: 20px;\n}\n\n\n@media screen and (max-width: tablet-l) {\n  .grid {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n\n  .flexColumn {\n    flex-direction: column;\n  }\n\n  .buttonBackTo {\n    display: none;\n  }\n\n  .recap {\n    width: 90vw;\n    margin: auto;\n  }\n\n  .submitButton {\n    width: 100%;\n  }\n  \n  .content {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: tablet) {\n  .modal {\n    width: 90%;\n    box-sizing: border-box;\n  }\n}\n\n.button {\n  border: 1px solid #E2E9FC;\n  border-radius: 5px;\n  text-align: left;\n\n  height: 48px;\n  width: 100%;\n  margin-right: 16px;\n  margin-bottom: 16px;\n  padding: 0 16px;\n  font-size: 14px;\n\n  transition: .3s;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.button input {\n  margin-right: 8px;\n}\n\n.button:hover,\n.active {\n  border-color: color-purple;\n}\n\n.button:disabled {\n  background-color: #FAFBFE;\n}\n\n.button:disabled:hover {\n  border-color: #E2E9FC;\n}\n\n.card img+img {\n  margin-left: 8px;\n}\n\n\n\n.paymentContainer {\n  background-color: white;\n  padding: 16px;\n}\n\n.subtitle {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 4px;\n  margin-top: 0;\n}\n\n.description {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  color: color-text-subtle;\n  margin-top: 4px;\n}\n\n.hide {\n  display: none;\n}\n\n.method {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n@media screen and (max-width: tablet) {\n  .button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"content": `T3duOCpntJ3j3aSwpgY3`,
	"grid": `QlrOfPj5fVqQH5PVPgYQ`,
	"recap": `Oe0bAFkQfa3dyZYeCIdg`,
	"title": `rLsXwUj3SxlBwBkbT065`,
	"recapSection": `soIxxho0euBDB_conCww`,
	"boxForm": `MMwp7ZNu68KDfi9q1cF3`,
	"flexBox": `wzlaO_8nYQfnfJs82Qcv`,
	"flexColumn": `cOMf9LTb6eixcj43bcnJ`,
	"footerContainer": `xHWm8E28W7APonRRWp5q`,
	"buttonBackTo": `zTmzNvjGKC6pwL19Hsb7`,
	"bold": `O3TuKI_rOIMAv9ra88xa`,
	"icon": `JLttz2YIGzHEaMhjQ0Hp`,
	"switchCompany": `edWie6aJ006No8zDypag`,
	"background": `izCFl_joXr6lRcE4TvQm`,
	"modal": `ruaLoH4u7UK7kEFIGgfM`,
	"row": `c7OtxqajS2zLVuS8Qky8`,
	"inputContainer": `qgg7QTVvAvzVmQmrbF8t`,
	"submitButton": `YMM6knAIf3lZTG3Ymg18`,
	"button": `JB8fgVVoKSBbf5XqTtYx`,
	"active": `dEtJi4Ahxb_SAsa8Q3oK`,
	"card": `Od3yb_80fxke1asbzx3g`,
	"paymentContainer": `ADqX5xYUlD2ZQV_E19xf`,
	"subtitle": `c9SzhPohesHLGAeLPLCn`,
	"description": `M2PYiJBabPHuNEbglRcx`,
	"hide": `KnJs4t0zLve7l7Ej8Emm`,
	"method": `g3ZUyinLkKMFyq56LWWS`
};
export default ___CSS_LOADER_EXPORT___;
